import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import React from "react";
import { DeleteArticlesModal } from "@coworker/app/src/components/RoomSettings/Organisms/Modals/DeleteArticlesModal";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { DeleteArticleConfirmModal } from "@coworker/app/src/components/RoomSettings/Organisms/Modals/DeleteArticleConfirmModal";
import { Trans } from "@coworker/locales";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { useWorkspacesAction } from "@coworker/app/src/hooks/useWorkspaces";
import { logEvent } from "@coworker/app/src/helpers/tracker";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { Article } from "@coworker/app/src/components/RoomSettings/types/article";

interface ItemDeleteProps {
  itemNo: string;
  isItemInMultipleGroups: boolean;
  article: AggregatedArticle | Article;
  media: Media;
}

export const ItemDelete = ({
  itemNo,
  isItemInMultipleGroups,
  article,
  media,
}: ItemDeleteProps) => {
  const [trashcanModalOpen, setTrashcanModalOpen] = React.useState(false);
  const { showToast } = useToastNotification();
  const { pop } = useWorkspacesAction();

  const onDeleteArticle = () => {
    setTrashcanModalOpen(true);
    logEvent("ce:MM_articles_selected_deleteproduct");
  };

  const handlePostDelete = async () => {
    showToast(<Trans>articleDeletedString</Trans>);
    if (article.isFromArticleView) {
      pop();
    }
  };

  return (
    <>
      <FixaButton
        aria-label={"Delete"}
        size="small"
        iconOnly={true}
        ssrIcon={TrashCanIconPath}
        onClick={onDeleteArticle}
      />
      {trashcanModalOpen &&
        (isItemInMultipleGroups ? (
          <DeleteArticlesModal
            itemNo={itemNo}
            aggregatedArticle={article as AggregatedArticle}
            media={media}
            onClose={() => {
              setTrashcanModalOpen(false);
            }}
          />
        ) : (
          <DeleteArticleConfirmModal
            article={article as Article}
            onModalOpenChange={setTrashcanModalOpen}
            postDeleteFunction={handlePostDelete}
          />
        ))}
    </>
  );
};
